/* External */
import { array, bool, func, number, string } from 'prop-types'
import React from 'react'

/* Internal */
import { isEmpty } from '../../../utilities/GeneralUtils'

const TypeaheadResults = ({
  onSearchResultItemSelectRequest,
  allQuickSearchResults,
  selectedIndex,
  show,
  cmpRef,
  searchProviderId,
  searchString,
}) => {
  // console.log('SearchResults - selectedIndex: ' + selectedIndex)
  const handleItemSelect = function (searchResult) {
    searchResult.searchString = searchString
    onSearchResultItemSelectRequest(searchResult)
  }

  let searchResultsList = ''
  let currentType

  if (!isEmpty(allQuickSearchResults)) {
    searchResultsList = allQuickSearchResults.map((searchResult, i) => {
      let newType

      const resultName = searchResult.name
      let styleName = `searchResult ${searchResult.type}`

      if (i === selectedIndex) {
        styleName = `searchResult active ${searchResult.type}`
      }

      if (!currentType || currentType !== searchResult.type) {
        currentType = searchResult.type
        newType = true
      } else {
        newType = false
      }

      if (newType) {
        return (
          <div key={i}>
            <div
              className={`search-result-section--${searchResult.type}${
                isEmpty(searchProviderId) ? '' : ` ${searchProviderId}`
              }`}
            />
            <div
              className={styleName}
              onClick={() => handleItemSelect(searchResult)}
              data-ref={`${cmpRef}-${i}`}
            >
              {resultName}
            </div>
          </div>
        )
      }

      return (
        <div
          key={i}
          className={styleName}
          onClick={() => handleItemSelect(searchResult)}
          data-ref={`${cmpRef}-${i}`}
        >
          {resultName}
        </div>
      )
    })
  }

  const styleClass = isEmpty(allQuickSearchResults)
    ? 'searchbar__results'
    : 'searchbar__results searchbar__results--active'

  if (show) {
    return (
      <div className={styleClass}>
        <div className="searchResults">{searchResultsList}</div>
      </div>
    )
  }

  return <div />
}

TypeaheadResults.propTypes = {
  onSearchResultItemSelectRequest: func.isRequired,
  allQuickSearchResults: array.isRequired,
  selectedIndex: number.isRequired,
  show: bool.isRequired,
  searchProviderId: string,
  cmpRef: string,
  searchString: string,
}

export default TypeaheadResults
